'use strict';

const Mn = require('backbone.marionette');
const Template = require('communication/ui/comment/template/reaction-selector.hbs');

class ReactionSelectorView extends Mn.View {
    get tagName() {
        return 'div';
    }

    get className() {
        return 'comment-reaction-selector';
    }

    get template() {
        return Template;
    }

    triggers() {
        return {
            'click .add-thumbs-up-reaction': 'add:thumbs:up:reaction'
        };
    }

    templateContext() {
        const mappings = this.getOption('mappings');

        return mappings;
    }
}

module.exports = ReactionSelectorView;



// WEBPACK FOOTER //
// ./communication/ui/comment/view/reaction-selector.js